// Generated by `bazel run //pass_ml/js/autofill:write_sorted_features`. Do not edit.

import { getComputerForFeatures } from "@protontech/autofill/features/feature";
import {
  inputIterator,
  form,
  fields,
  btns,
  nearestHeadingsText,
  formTextAttrText,
  formAttributes,
  layouts,
  doc,
  anchors,
  parent,
  fieldsets,
  inputs,
  visibleFields,
  selects,
  textareas,
  candidateBtns,
  btnsTypeSubmit,
  headingsMultistep,
  headingsRecovery,
  headingsPwReset,
  headingsRegister,
  headingsLogin,
  headingsOTPOutlier,
  formTextHaystack,
  formTextRecovery,
  formTextPwReset,
  formTextRegister,
  formTextLogin,
  formAttrsMFA,
  formAttrsRecovery,
  formAttrsPwReset,
  formAttrsRegister,
  formAttrsLogin,
  formOTPOutlier,
  layoutHaystack,
  pageDescriptionText,
  anchorsHaystack,
  captchas,
  socials,
  fieldsetsCount,
  passwords,
  mfaInputs,
  emails,
  usernames,
  checkboxes,
  hidden,
  inputRatio,
  numbers,
  dates,
  files,
  tels,
  ccInputs,
  readOnly,
  radios,
  texts,
  visibleInputs,
  submits,
  visibleFieldsCount,
  ccSelects,
  selectsCount,
  textareasCount,
  btnHaystack,
  submitBtns,
  headingsMultiAuth,
  searchForm,
  newsletterForm,
  formTextMFA,
  layoutRecovery,
  layoutPwReset,
  layoutRegister,
  layoutLogin,
  pageRecovery,
  pagePwReset,
  pageRegister,
  pageLogin,
  troubleLink,
  hasCaptchas,
  oauths,
  passwordsByVisibility,
  pwHaystack,
  mfaInputsHaystack,
  emailRatio,
  emailsCount,
  identifiers,
  usernameRatio,
  usernamesCount,
  checkboxesHaystack,
  checkboxRatio,
  hiddenRatio,
  hiddenCount,
  formComplexity,
  hasNumber,
  hasDate,
  hasFiles,
  hasTels,
  readOnlyCount,
  radiosCount,
  textsCount,
  required,
  disabled,
  visibleRatio,
  autofocused,
  threeOrMoreVisibleFields,
  twoVisibleFields,
  oneVisibleField,
  visibleInputsCount,
  formInputMFACandidates,
  submitsCount,
  ccs,
  linkOTPOutlier,
  submitBtnHaystack,
  formMFA,
  pageMultiAuth,
  hasOAuth,
  visiblePasswords,
  hiddenPasswords,
  pwConfirmRegister,
  pwNewRegister,
  inputsMFA,
  identifiersByVisibility,
  TOSRef,
  rememberMeCheckbox,
  requiredRatio,
  disabledRatio,
  disabledCount,
  visibleRatio_visibleFieldsCount,
  ccsCount,
  identities,
  buttonMultistep,
  submitRecovery,
  submitRegister,
  submitLogin,
  visiblePasswordsCount,
  passwordRatio,
  autofocusedIsPassword,
  threeOrMorePasswords,
  twoPasswords,
  onePassword,
  noPasswords,
  hiddenPasswordRatio,
  hiddenPasswordsCount,
  maybeMFA,
  visibleIdentifiers,
  hiddenIdentifiers,
  requiredRatio_visibleFieldsCount,
  identitiesCount,
  multistepForm,
  submitMultiAuth,
  passwordRatio_visibleFieldsCount,
  haystackMFA,
  identifierHaystack,
  identifierRatio,
  autofocusedIsIdentifier,
  threeOrMoreIdentifiers,
  twoIdentifiers,
  oneIdentifier,
  noIdentifiers,
  visibleIdentifiersCount,
  hiddenIdentifierRatio,
  hiddenIdentifiersCount,
  requiredRatio_multistepForm,
  passwordRatio_multistepForm,
  visibleRatio_multistepForm,
  multiAuthForm,
  requiredRatio_visiblePasswordsCount,
  passwordRatio_visiblePasswordsCount,
  visibleRatio_visiblePasswordsCount,
  requiredRatio_hiddenPasswordsCount,
  passwordRatio_hiddenPasswordsCount,
  visibleRatio_hiddenPasswordsCount,
  formTextAuthenticator,
  identifierRecovery,
  identifierRatio_multistepForm,
  identifierRatio_hiddenPasswordsCount,
  identifierRatio_visiblePasswordsCount,
  identifierRatio_visibleFieldsCount,
  requiredRatio_multiAuthForm,
  passwordRatio_multiAuthForm,
  identifierRatio_multiAuthForm,
  visibleRatio_multiAuthForm,
  multistepForm_multiAuthForm,
  requiredRatio_visibleIdentifiersCount,
  passwordRatio_visibleIdentifiersCount,
  identifierRatio_visibleIdentifiersCount,
  visibleRatio_visibleIdentifiersCount,
  requiredRatio_hiddenIdentifiersCount,
  passwordRatio_hiddenIdentifiersCount,
  identifierRatio_hiddenIdentifiersCount,
  visibleRatio_hiddenIdentifiersCount,
} from "./abstract.form";
import type { formFeatures } from "./abstract.form";

export const formFeaturesComputer = getComputerForFeatures<typeof formFeatures>({
  sorted: [
    inputIterator,
    form,
    fields,
    btns,
    nearestHeadingsText,
    formTextAttrText,
    formAttributes,
    layouts,
    doc,
    anchors,
    parent,
    fieldsets,
    inputs,
    visibleFields,
    selects,
    textareas,
    candidateBtns,
    btnsTypeSubmit,
    headingsMultistep,
    headingsRecovery,
    headingsPwReset,
    headingsRegister,
    headingsLogin,
    headingsOTPOutlier,
    formTextHaystack,
    formTextRecovery,
    formTextPwReset,
    formTextRegister,
    formTextLogin,
    formAttrsMFA,
    formAttrsRecovery,
    formAttrsPwReset,
    formAttrsRegister,
    formAttrsLogin,
    formOTPOutlier,
    layoutHaystack,
    pageDescriptionText,
    anchorsHaystack,
    captchas,
    socials,
    fieldsetsCount.parents.fieldsetsCount,
    passwords,
    mfaInputs,
    emails,
    usernames,
    checkboxes,
    hidden,
    inputRatio,
    numbers,
    dates,
    files,
    tels,
    ccInputs,
    readOnly,
    radios,
    texts,
    visibleInputs,
    submits,
    visibleFieldsCount.parents.visibleFieldsCount,
    ccSelects,
    selectsCount.parents.selectsCount,
    textareasCount.parents.textareasCount,
    btnHaystack,
    submitBtns,
    headingsMultiAuth,
    searchForm,
    newsletterForm,
    formTextMFA,
    layoutRecovery,
    layoutPwReset,
    layoutRegister,
    layoutLogin,
    pageRecovery,
    pagePwReset,
    pageRegister,
    pageLogin,
    troubleLink,
    hasCaptchas,
    oauths,
    fieldsetsCount,
    passwordsByVisibility,
    pwHaystack,
    mfaInputsHaystack,
    emailRatio,
    emailsCount.parents.emailsCount,
    identifiers,
    usernameRatio,
    usernamesCount.parents.usernamesCount,
    checkboxesHaystack,
    checkboxRatio,
    hiddenRatio,
    hiddenCount.parents.hiddenCount,
    formComplexity.parents.formComplexity,
    hasNumber,
    hasDate,
    hasFiles,
    hasTels,
    readOnlyCount.parents.readOnlyCount,
    radiosCount.parents.radiosCount,
    textsCount.parents.textsCount,
    required,
    disabled,
    visibleRatio,
    autofocused,
    threeOrMoreVisibleFields,
    twoVisibleFields,
    oneVisibleField,
    visibleInputsCount.parents.visibleInputsCount,
    formInputMFACandidates,
    submitsCount.parents.submitsCount,
    visibleFieldsCount,
    ccs,
    selectsCount,
    textareasCount,
    linkOTPOutlier,
    submitBtnHaystack,
    formMFA,
    pageMultiAuth,
    hasOAuth,
    visiblePasswords,
    hiddenPasswords,
    pwConfirmRegister,
    pwNewRegister,
    inputsMFA,
    emailsCount,
    identifiersByVisibility,
    usernamesCount,
    TOSRef,
    rememberMeCheckbox,
    hiddenCount,
    formComplexity,
    readOnlyCount,
    radiosCount,
    textsCount,
    requiredRatio,
    disabledRatio,
    disabledCount.parents.disabledCount,
    visibleInputsCount,
    submitsCount,
    visibleRatio_visibleFieldsCount,
    ccsCount.parents.ccsCount,
    identities,
    buttonMultistep,
    submitRecovery,
    submitRegister,
    submitLogin,
    visiblePasswordsCount.parents.visiblePasswordsCount,
    passwordRatio,
    autofocusedIsPassword,
    threeOrMorePasswords,
    twoPasswords,
    onePassword,
    noPasswords,
    hiddenPasswordRatio,
    hiddenPasswordsCount.parents.hiddenPasswordsCount,
    maybeMFA,
    visibleIdentifiers,
    hiddenIdentifiers,
    requiredRatio_visibleFieldsCount,
    disabledCount,
    ccsCount,
    identitiesCount.parents.identitiesCount,
    multistepForm,
    submitMultiAuth,
    visiblePasswordsCount,
    passwordRatio_visibleFieldsCount,
    hiddenPasswordsCount,
    haystackMFA,
    identifierHaystack,
    identifierRatio,
    autofocusedIsIdentifier,
    threeOrMoreIdentifiers,
    twoIdentifiers,
    oneIdentifier,
    noIdentifiers,
    visibleIdentifiersCount.parents.visibleIdentifiersCount,
    hiddenIdentifierRatio,
    hiddenIdentifiersCount.parents.hiddenIdentifiersCount,
    identitiesCount,
    requiredRatio_multistepForm,
    passwordRatio_multistepForm,
    visibleRatio_multistepForm,
    multiAuthForm,
    requiredRatio_visiblePasswordsCount,
    passwordRatio_visiblePasswordsCount,
    visibleRatio_visiblePasswordsCount,
    requiredRatio_hiddenPasswordsCount,
    passwordRatio_hiddenPasswordsCount,
    visibleRatio_hiddenPasswordsCount,
    formTextAuthenticator,
    identifierRecovery,
    identifierRatio_multistepForm,
    identifierRatio_hiddenPasswordsCount,
    identifierRatio_visiblePasswordsCount,
    identifierRatio_visibleFieldsCount,
    visibleIdentifiersCount,
    hiddenIdentifiersCount,
    requiredRatio_multiAuthForm,
    passwordRatio_multiAuthForm,
    identifierRatio_multiAuthForm,
    visibleRatio_multiAuthForm,
    multistepForm_multiAuthForm,
    requiredRatio_visibleIdentifiersCount,
    passwordRatio_visibleIdentifiersCount,
    identifierRatio_visibleIdentifiersCount,
    visibleRatio_visibleIdentifiersCount,
    requiredRatio_hiddenIdentifiersCount,
    passwordRatio_hiddenIdentifiersCount,
    identifierRatio_hiddenIdentifiersCount,
    visibleRatio_hiddenIdentifiersCount,
  ],
  features: [
    "visibleFieldsCountScaled",
    "visibleInputsCountScaled",
    "fieldsetsCountScaled",
    "textsCountScaled",
    "textareasCountScaled",
    "selectsCountScaled",
    "disabledCountScaled",
    "radiosCountScaled",
    "readOnlyCountScaled",
    "formComplexityScaled",
    "visibleIdentifiersCountScaled",
    "hiddenIdentifiersCountScaled",
    "usernamesCountScaled",
    "emailsCountScaled",
    "hiddenCountScaled",
    "hiddenPasswordsCountScaled",
    "submitsCountScaled",
    "identitiesCountScaled",
    "ccsCountScaled",
    "hasTels",
    "hasOAuth",
    "hasCaptchas",
    "hasFiles",
    "hasDate",
    "hasNumber",
    "oneVisibleField",
    "twoVisibleFields",
    "threeOrMoreVisibleFields",
    "noPasswords",
    "onePassword",
    "twoPasswords",
    "threeOrMorePasswords",
    "noIdentifiers",
    "oneIdentifier",
    "twoIdentifiers",
    "threeOrMoreIdentifiers",
    "autofocusedIsIdentifier",
    "autofocusedIsPassword",
    "visibleRatio",
    "inputRatio",
    "hiddenRatio",
    "identifierRatio",
    "emailRatio",
    "usernameRatio",
    "passwordRatio",
    "disabledRatio",
    "requiredRatio",
    "checkboxRatio",
    "hiddenIdentifierRatio",
    "hiddenPasswordRatio",
    "pageLogin",
    "formTextLogin",
    "formAttrsLogin",
    "headingsLogin",
    "layoutLogin",
    "rememberMeCheckbox",
    "troubleLink",
    "submitLogin",
    "pageRegister",
    "formTextRegister",
    "formAttrsRegister",
    "headingsRegister",
    "layoutRegister",
    "pwNewRegister",
    "pwConfirmRegister",
    "submitRegister",
    "TOSRef",
    "pagePwReset",
    "formTextPwReset",
    "formAttrsPwReset",
    "headingsPwReset",
    "layoutPwReset",
    "pageRecovery",
    "formTextRecovery",
    "formAttrsRecovery",
    "headingsRecovery",
    "layoutRecovery",
    "identifierRecovery",
    "submitRecovery",
    "formTextMFA",
    "formAttrsMFA",
    "inputsMFA",
    "newsletterForm",
    "searchForm",
    "multistepForm",
    "multiAuthForm",
    "multistepForm,multiAuthForm",
    "visibleRatio,visibleFieldsCountScaled",
    "visibleRatio,visibleIdentifiersCountScaled",
    "visibleRatio,visiblePasswordsCountScaled",
    "visibleRatio,hiddenIdentifiersCountScaled",
    "visibleRatio,hiddenPasswordsCountScaled",
    "visibleRatio,multiAuthForm",
    "visibleRatio,multistepForm",
    "identifierRatio,visibleFieldsCountScaled",
    "identifierRatio,visibleIdentifiersCountScaled",
    "identifierRatio,visiblePasswordsCountScaled",
    "identifierRatio,hiddenIdentifiersCountScaled",
    "identifierRatio,hiddenPasswordsCountScaled",
    "identifierRatio,multiAuthForm",
    "identifierRatio,multistepForm",
    "passwordRatio,visibleFieldsCountScaled",
    "passwordRatio,visibleIdentifiersCountScaled",
    "passwordRatio,visiblePasswordsCountScaled",
    "passwordRatio,hiddenIdentifiersCountScaled",
    "passwordRatio,hiddenPasswordsCountScaled",
    "passwordRatio,multiAuthForm",
    "passwordRatio,multistepForm",
    "requiredRatio,visibleFieldsCountScaled",
    "requiredRatio,visibleIdentifiersCountScaled",
    "requiredRatio,visiblePasswordsCountScaled",
    "requiredRatio,hiddenIdentifiersCountScaled",
    "requiredRatio,hiddenPasswordsCountScaled",
    "requiredRatio,multiAuthForm",
    "requiredRatio,multistepForm",
  ],
  private: ["formInputMFACandidates", "formMFA", "formOTPOutlier", "formTextAuthenticator", "headingsOTPOutlier", "inputIterator", "linkOTPOutlier"],
});
